export default __webpack_public_path__ + "static/helix-bq-scheda-tecnica-64d3e814fe6a4e1189248102d2f70af2.pdf";